import * as React from 'react';
import * as styles from '../styles.scss';
import { Fallback, NumericInput } from 'components/common';
import { IState } from 'redux/global-reducers';
import * as classNames from 'classnames';
import { WithNamespaces, withNamespaces } from 'react-i18next';
import { connect } from 'react-redux';
import { handleError } from 'utils/common';
import { withErrorBoundary } from 'react-error-boundary';
import { IOrderForm, IOrderFormConfig, OrderFormFieldKey } from '../config';
import { FormikErrors } from 'formik';
import { OrderType } from 'constants/enum';

interface ITradingValueSectionProps
  extends React.ClassAttributes<TradingValueComponent>,
    WithNamespaces {
  readonly config: IOrderFormConfig;
  readonly values: IOrderForm;
  readonly quantityStep: number;
  readonly isDerivatives: boolean;
  readonly onChangeTradingValue: (tradingValue?: number) => void;
  readonly onBlurTradingValue: () => void;

  readonly ErrorMessage: React.FC<{
    readonly message?: string;
  }>;
  readonly errors: FormikErrors<IOrderForm>;
}

class TradingValueComponent extends React.Component<ITradingValueSectionProps> {
  render() {
    const {
      t,
      config,
      ErrorMessage,
      errors,
      values,
      isDerivatives,
      onChangeTradingValue,
      onBlurTradingValue,
      quantityStep,
    } = this.props;
    return (
      <>
        {config[OrderFormFieldKey.TRADING_VALUE] != null && (
          <div
            className={classNames(
              styles.TradingValueSection,
              styles.FormField,
              {
                [styles.HiddenField]:
                  isDerivatives ||
                  (values.orderType !== OrderType.LO &&
                    values.orderType !== OrderType.ODDLOT &&
                    values.orderType !== OrderType.BUY_IN),
              }
            )}
            style={config[OrderFormFieldKey.TRADING_VALUE]?.style}
          >
            <div className={styles.MainField}>
              <div className={styles.FieldTitle}>{t('Trading Value')}</div>
              <div
                className={classNames(styles.FieldInput, styles.MarginTop16)}
              >
                <NumericInput
                  onNumberChange={onChangeTradingValue}
                  disabled={values.orderQuantityType !== 'amount'}
                  value={values.tradingValue}
                  step={quantityStep}
                  onBlur={onBlurTradingValue}
                />
              </div>
            </div>
            <ErrorMessage message={errors.tradingValue} />
          </div>
        )}
      </>
    );
  }
}

const mapStateToProps = (state: IState) => ({});

const mapDispatchToProps = {};

const TradingValueSection = withErrorBoundary(
  withNamespaces('common')(
    connect(mapStateToProps, mapDispatchToProps)(TradingValueComponent)
  ),
  Fallback,
  handleError
);

export default TradingValueSection;



// WEBPACK FOOTER //
// ./src/components/common/OrderForm/FormSection/TradingValue.tsx